import { useTranslation } from 'react-i18next'
import { StatusText } from '@/features/Application/elements'

const StatusComponent = ({ status, isLocked, fallbackText }) => {
  const { t } = useTranslation()

  const texts = {
    verified: t('common.verified', 'Verified'),
    unverified: t('l.application.view.removed.label', 'Removed'),
    pending: t('l.application.view.pending.label', 'Pending')
  }

  const text = status === 'unverified' && !!fallbackText ? fallbackText : texts?.[status]

  const types = {
    verified: 'success',
    unverified: 'default',
    pending: 'default'
  }

  const type = types?.[status]

  return <StatusText title={text} type={type} isLocked={isLocked} />
}

export default StatusComponent
